import type { W2SentenceGuide as Guide } from '../utils/api';

export default function W2SentenceGuide({ guide }: { guide: Guide }) {
  return (
    <div className="mt-4 space-y-3 rounded-xl border border-emerald-200 bg-emerald-50 p-4 text-sm leading-6 text-slate-800" data-w2-guide={guide.question_id}>
      <div className="flex flex-wrap items-center gap-2">
        <span className="font-semibold text-emerald-900">生词：{guide.word}</span>
        <span className="rounded-full bg-white px-2.5 py-0.5 font-medium text-emerald-800">{guide.word_type}</span>
      </div>
      <p><strong>词义：</strong>{guide.meaning}</p>
      <div>
        <p className="break-words font-semibold text-emerald-900">简单句型：{guide.pattern}</p>
        <p className="mt-1 text-slate-600">{guide.pattern_zh}</p>
      </div>
      <p><strong>用法与易错点：</strong>{guide.usage}</p>
      <div>
        <p><strong>参考例句：</strong>{guide.example}</p>
        <p className="mt-1 break-words text-slate-600">成分拆解：{guide.breakdown}</p>
      </div>
      <p className="text-xs text-slate-500">例句用于学习词语；请根据原题图片调整，造句没有唯一答案。</p>
    </div>
  );
}
